import { render, staticRenderFns } from "./ProviderAdd.vue?vue&type=template&id=7afc6d55&scoped=true&"
import script from "./ProviderAdd.vue?vue&type=script&lang=js&"
export * from "./ProviderAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProviderAdd.vue?vue&type=style&index=0&id=7afc6d55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc6d55",
  null
  
)

export default component.exports